var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseCircleHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_close_circle_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_close_circle_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#E7EAEC",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6503786,6.29502041 L6.29077246,10.6808959 C5.90142297,11.0725915 5.90332484,11.7057536 6.29502041,12.0951031 C6.68671598,12.4844526 7.3198781,12.4825507 7.70922759,12.0908552 L12.0688337,7.70497964 C12.4581832,7.31328408 12.4562814,6.68012195 12.0645858,6.29077246 C11.6728902,5.90142297 11.0397281,5.90332484 10.6503786,6.29502041 Z",
    id: "Path-7",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29139494,7.70560532 L10.6495561,12.0822945 C11.0392511,12.4736463 11.6724147,12.4749893 12.0637665,12.0852943 C12.4551183,11.6955992 12.4564613,11.0624357 12.0667662,10.6710839 L7.70860509,6.29439471 C7.31891004,5.90304293 6.68574649,5.90169989 6.29439471,6.29139494 C5.90304293,6.68108999 5.90169989,7.31425354 6.29139494,7.70560532 Z",
    id: "Path-7",
    fill: "#B1B1B1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCircleHover);
export default __webpack_public_path__ + "static/media/icon_close_circle_hover.efb1c28cc5aca8f0aabd4f20cec01394.svg";
export { ForwardRef as ReactComponent };